import React from "react";
import { Typography } from "@material-tailwind/react";
import PropTypes from 'prop-types';

export default function SpinningTitle({theTitle = ''}) {

    return (
            <Typography variant="h2" className="!normal-case !text-4xl" >
                metri<span data-testid='spinning-q' className="rotate-q !uppercase">Q</span> {theTitle}
            </Typography>
    );
}

SpinningTitle.propTypes = {
    theTitle: PropTypes.string,
};